import "../styles.css"
function Header() {
    return (
      <div className="header">
        <h2>InsightBoard</h2>
      </div>
    );
  }
  
  export default Header;